export default __webpack_public_path__ + "static/media/pvn-arte-4.fe07191e.webp";